<template>
  <div class="not-found">
    <h1>404</h1>
    <h2>Page Not Found</h2>
    <p>The page you are looking for doesn't exist.</p>
    
    <!-- Link to take them back to safety -->
    <!-- <router-link to="/">Go back to Home</router-link> -->
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.not-found {
  text-align: center;
  margin-top: 100px;
}
.not-found h1 {
  font-size: 80px;
  margin-bottom: 0;
}
</style>